import Vuex from "vuex";

const store = new Vuex.Store({
    modules: {}
});

export default store;
